import React, { useState } from 'react';
import { Video } from '../Video';
import { Modal } from '../Modal';
import { isFunctionalCookiesBlocked } from '../../utils/cookieConsent';
export const VideoLightbox = ({ isOpen, onClose, closeIconLabel, video, videoLabel, videoHeight, isContained, }) => {
    // if true - handle video end state when count down ends
    const [shouldModalClose, setShouldModalClose] = useState(false);
    return (React.createElement(Modal, { onModalClose: () => {
            onClose();
            setShouldModalClose(false);
        }, isContained: isContained, isOpen: isOpen, shouldModalClose: shouldModalClose, 
        // finalize aria-label approach app-wide
        closeIconLabel: closeIconLabel ? closeIconLabel : 'Close Lightbox', asLightbox: true },
        React.createElement(React.Fragment, null, !isFunctionalCookiesBlocked() && (React.createElement(Video, { media: video, ariaLabel: videoLabel, onCompleted: () => setShouldModalClose(true), hasCountdown: true, height: videoHeight })))));
};
